import { gql } from '@apollo/client';
import { IBaseDocument } from 'FeatureModules/Document/types/document.types';
import { IGraphQlConnection } from 'types/core.types';
import { DOCUMENT_FRAGMENT } from '../fragments/document.fragments';

export interface IGetDocumentsValues {
  documents: IGraphQlConnection<IBaseDocument>;
  pageInfo: {
    endCursor: string;
  };
}

export const GET_DOCUMENTS = gql`
  query GetDocuments($first: Int, $after: String, $filters: DocumentsFilters) {
    documents(first: $first, after: $after, filters: $filters) {
      edges {
        node {
          ...documentValues
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
  ${DOCUMENT_FRAGMENT}
`;

export const GET_SHARED_DOCUMENTS = gql`
  query GetSharedDocuments($first: Int, $after: String, $filters: SharedDocumentsFilters) {
    sharedDocuments(first: $first, after: $after, filters: $filters) {
      edges {
        node {
          ...documentValues
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
  ${DOCUMENT_FRAGMENT}
`;

export const GET_DOCUMENT = gql`
  query GetDocument($id: UUID!) {
    document(id: $id) {
      ...documentValues
    }
  }
  ${DOCUMENT_FRAGMENT}
`;
